import { render, staticRenderFns } from "./EventPreview.vue?vue&type=template&id=35887f7d&scoped=true"
import script from "./EventPreview.vue?vue&type=script&lang=js"
export * from "./EventPreview.vue?vue&type=script&lang=js"
import style0 from "./EventPreview.vue?vue&type=style&index=0&id=35887f7d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35887f7d",
  null
  
)

export default component.exports